import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';

import { ApiService } from '../../services/ApiService'; //remove
@Component({
  selector: 'app-list-right',
  templateUrl: './list-right.component.html',
  styleUrls: ['./list-right.component.scss']
})
export class ListRightComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  dynamicClass: string;
  jssStylingService: JssStylingService;
  
  submissionResponse: string =""; //remove

  constructor(jssStylingService: JssStylingService,protected apiService: ApiService ) { 
    this.jssStylingService = jssStylingService;
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('listRight component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
  }


}
